module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-037d6027b0d31b8c702295f11c8f7620.svg";